import { ChevronDown } from "lucide-react"
import { ComponentPropsWithRef, RefObject } from "react"

import { Button } from "../../../../../components/base/control/Button"
import { classNames } from "../../../../../lib/classNames"

interface SortPopoverButtonProps extends ComponentPropsWithRef<"button"> {
  label: string
  ref?: RefObject<HTMLButtonElement | null>
}

export const SortPopoverButton = (props: SortPopoverButtonProps) => {
  const { ref, label, className, ...otherProps } = props

  return (
    <Button
      ref={ref}
      mode="secondary"
      className={classNames(className, "flex flex-row gap-1 px-2 py-1")}
      rightIcon={ChevronDown}
      size="small"
      {...otherProps}
    >
      {label}
    </Button>
  )
}
